import { render } from "./OrdersView.vue?vue&type=template&id=c281d10a"
import script from "./OrdersView.vue?vue&type=script&lang=js"
export * from "./OrdersView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__